import { EventType, VehicleStatus } from "./types";

export const statusColor: Record<VehicleStatus, string> = {
  online: "#22c55e",
  offline: "#94a3b8",
};

export const EVENT_CONFIG: Record<EventType, { color: string; label: string }> = {
  speeding: { color: "#f97316", label: "Speeding" },
  hardCornering: { color: "#8b5cf6", label: "Hard Cornering" },
  harshBraking: { color: "#ef4444", label: "Harsh Braking" },
  lostGPS: { color: "#6b7280", label: "Lost GPS" },
  lostGSM: { color: "#3b82f6", label: "Lost GSM" },
  harshAcceleration: { color: "#eab308", label: "Harsh Acceleration" },
};

export const HOURS = [2, 4, 8, 12, 24];
